// This file was automatically generated from print.order.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.order');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.order.section = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.text) ? '<div class="mt10"><p class="normalText"><span class="el8Bold">' + soy.$$escapeHtml(opt_data.title) + ':</span><br>' + soy.$$escapeHtml(opt_data.text) + '</p></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.order.testsSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.order.testNames.length) {
    output.append('<div class="subHeadingLabel emphasis fl">Tests:</div><div class="sectionTextwLabel emphasis"><ul class="fieldSavedList">');
    var testList15853 = opt_data.order.testNames;
    var testListLen15853 = testList15853.length;
    for (var testIndex15853 = 0; testIndex15853 < testListLen15853; testIndex15853++) {
      var testData15853 = testList15853[testIndex15853];
      output.append('<li class="fieldSavedBullet">', soy.$$escapeHtml(testData15853), '</li>');
    }
    output.append('</ul></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.order.icd9Section = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.order.icd9Codes.length) {
    output.append('<div class="mt10 normalText"><span class="el8Bold">ICD-9s:</span><div class="sectionTextwLabel"><ul class="fieldSavedList">');
    var cList15863 = opt_data.order.icd9Codes;
    var cListLen15863 = cList15863.length;
    for (var cIndex15863 = 0; cIndex15863 < cListLen15863; cIndex15863++) {
      var cData15863 = cList15863[cIndex15863];
      output.append('<li class="fieldSavedBullet">', soy.$$escapeHtml(cData15863), '</li>');
    }
    output.append('</ul></div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.order.dxsSectionBullets = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.order.icd10Codes.length) {
    output.append('<div class="mt10 normalText"><span class="el8Bold">ICD-10s:</span><div class="sectionTextwLabel"><ul class="fieldSavedList">');
    var cList15873 = opt_data.order.icd10Codes;
    var cListLen15873 = cList15873.length;
    for (var cIndex15873 = 0; cIndex15873 < cListLen15873; cIndex15873++) {
      var cData15873 = cList15873[cIndex15873];
      output.append('<li class="fieldSavedBullet">', soy.$$escapeHtml(cData15873), '</li>');
    }
    output.append('</ul></div></div>');
  }
  if (opt_data.order.showDualCoding && opt_data.order.icd9Codes.length) {
    output.append('<div class="mt10 normalText"><span class="el8Bold">ICD-9s:</span><div class="sectionTextwLabel"><ul class="fieldSavedList">');
    var cList15882 = opt_data.order.icd9Codes;
    var cListLen15882 = cList15882.length;
    for (var cIndex15882 = 0; cIndex15882 < cListLen15882; cIndex15882++) {
      var cData15882 = cList15882[cIndex15882];
      output.append('<li class="fieldSavedBullet">', soy.$$escapeHtml(cData15882), '</li>');
    }
    output.append('</ul></div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.order.dxsSectionTwoLines = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.order.icd10Codes && opt_data.order.icd10Codes.length) {
    output.append('<div>ICD-10: ');
    var icd10List15892 = opt_data.order.icd10Codes;
    var icd10ListLen15892 = icd10List15892.length;
    for (var icd10Index15892 = 0; icd10Index15892 < icd10ListLen15892; icd10Index15892++) {
      var icd10Data15892 = icd10List15892[icd10Index15892];
      output.append(soy.$$escapeHtml(icd10Data15892), (! (icd10Index15892 == icd10ListLen15892 - 1)) ? ', ' : '');
    }
    output.append('</div>');
  }
  if (opt_data.order.icd9Codes && opt_data.order.icd9Codes.length) {
    output.append('<div>ICD-9: ');
    var icd9List15902 = opt_data.order.icd9Codes;
    var icd9ListLen15902 = icd9List15902.length;
    for (var icd9Index15902 = 0; icd9Index15902 < icd9ListLen15902; icd9Index15902++) {
      var icd9Data15902 = icd9List15902[icd9Index15902];
      output.append(soy.$$escapeHtml(icd9Data15902), (! (icd9Index15902 == icd9ListLen15902 - 1)) ? ', ' : '');
    }
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.order.ccsSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.order.ccNames.length) {
    output.append('<div class="mt10"><p class="normalText el8Bold">Copy To:</p>');
    var nameList15913 = opt_data.order.ccNames;
    var nameListLen15913 = nameList15913.length;
    for (var nameIndex15913 = 0; nameIndex15913 < nameListLen15913; nameIndex15913++) {
      var nameData15913 = nameList15913[nameIndex15913];
      output.append('<p class="normalText">', soy.$$escapeHtml(nameData15913), '</p>');
    }
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};
